import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { playerAvatarImgClassName } from '../../../utils/avatarClassNames';

function formatTeamInteger(value) {
	const parsed = parseFloat(value);
	if (Number.isNaN(parsed)) return '0';
	return Math.round(parsed).toLocaleString();
}

export default function ProjectionsTeamsTable({ teams }) {
	const [
		sortBy,
		setSortBy
	] = useState('proj_passing_yards');
	const [
		sortDirection,
		setSortDirection
	] = useState('desc');

	const sortedTeams = useMemo(
		() => {
			const items = [
				...teams
			];

			items.sort((a, b) => {
				const aValue = sortBy === 'name' ? (a.name || '').toLowerCase() : parseFloat(a[sortBy]) || 0;
				const bValue = sortBy === 'name' ? (b.name || '').toLowerCase() : parseFloat(b[sortBy]) || 0;

				if (typeof aValue === 'string' || typeof bValue === 'string') {
					const result = String(aValue).localeCompare(String(bValue));
					return sortDirection === 'asc' ? result : -result;
				}

				const result = aValue - bValue;
				return sortDirection === 'asc' ? result : -result;
			});

			return items;
		},
		[
			teams,
			sortBy,
			sortDirection
		]
	);

	const handleSort = (column) => {
		if (sortBy === column) {
			setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
		} else {
			setSortBy(column);
			setSortDirection('desc');
		}
	};

	const sortIndicator = (column) => {
		if (sortBy !== column) return '';
		return sortDirection === 'asc' ? ' ↑' : ' ↓';
	};

	const sortableHeaderClass = 'cursor-pointer hover:underline';

	return (
		<div className="overflow-x-auto">
			<table className="min-w-full text-sm text-gray-800 dark:text-dark-text">
				<thead>
					<tr className="border-b border-gray-200 dark:border-dark-border">
						<th className={`text-left py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('name')}>Team{sortIndicator('name')}</th>
						<th className={`text-right py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('proj_pass_attempts')}>Pass Att{sortIndicator('proj_pass_attempts')}</th>
						<th className={`text-right py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('proj_passing_yards')}>Pass Yds{sortIndicator('proj_passing_yards')}</th>
						<th className={`text-right py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('proj_passing_touchdowns')}>Pass TD{sortIndicator('proj_passing_touchdowns')}</th>
						<th className={`text-right py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('proj_rush_attempts')}>Rush Att{sortIndicator('proj_rush_attempts')}</th>
						<th className={`text-right py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('proj_rushing_yards')}>Rush Yds{sortIndicator('proj_rushing_yards')}</th>
						<th className={`text-right py-3 px-4 ${sortableHeaderClass}`} onClick={() => handleSort('proj_rushing_touchdowns')}>Rush TD{sortIndicator('proj_rushing_touchdowns')}</th>
						<th className="text-right py-3 px-4">Open</th>
					</tr>
				</thead>
				<tbody>
					{sortedTeams.map((team) => (
						<tr key={team.id} className="border-b border-gray-100 dark:border-dark-border">
							<td className="py-3 px-4">
								<div className="flex items-center gap-2">
									<div
										style={{
											width: '50px',
											height: '50px',
											overflow: 'hidden',
											marginRight: '8px'
										}}
									>
										<img
											className={playerAvatarImgClassName}
											src={`${team.image_url}?w=50&h=50`}
											alt={team.name}
											style={{
												width: '50px',
												height: '50px',
												minWidth: '50px',
												minHeight: '50px'
											}}
										/>
									</div>
									{team.name}
								</div>
							</td>
							<td className="py-3 px-4 text-right">{formatTeamInteger(team.proj_pass_attempts)}</td>
							<td className="py-3 px-4 text-right">{formatTeamInteger(team.proj_passing_yards)}</td>
							<td className="py-3 px-4 text-right">{formatTeamInteger(team.proj_passing_touchdowns)}</td>
							<td className="py-3 px-4 text-right">{formatTeamInteger(team.proj_rush_attempts)}</td>
							<td className="py-3 px-4 text-right">{formatTeamInteger(team.proj_rushing_yards)}</td>
							<td className="py-3 px-4 text-right">{formatTeamInteger(team.proj_rushing_touchdowns)}</td>
							<td className="py-3 px-4 text-right">
								<Link
									to={`/projections/team/${team.id}`}
									className="text-blue-500 hover:underline"
								>
									View
								</Link>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
